import { render } from "./IconCheck.vue?vue&type=template&id=386a6f43"
import script from "./IconCheck.vue?vue&type=script&lang=js"
export * from "./IconCheck.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/14/IconCheck.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "386a6f43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('386a6f43', __exports__)) {
    api.reload('386a6f43', __exports__)
  }
  
  module.hot.accept("./IconCheck.vue?vue&type=template&id=386a6f43", () => {
    api.rerender('386a6f43', render)
  })

}


export default __exports__